import { FC, Fragment } from 'react';

import { LoaderPinwheel } from 'lucide-react';
import { isEmpty, isNonNullish } from 'remeda';
import useSWR from 'swr';

import { AddStreamerWheelForm } from './addStreamerWheelForm/AddStreamerWheelForm';
import { StreamerWheelCard } from './streamerWheelCard/StreamerWheelCard';

import css from './StreamerWheelPage.module.css';

import { streamerWheelService } from 'v2/api/streamerWheelService';
import { Card } from 'v2/components/card/Card';
import { CardHeader } from 'v2/components/card/cardHeader/CardHeader';
import { EmptyPlaceholder } from 'v2/components/emptyPlaceholder/EmptyPlaceholder';
import { Loader } from 'v2/components/loader/Loader';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';

export const StreamerWheelPage: FC = () => {
  const { data, isLoading, mutate } = useSWR('getStreamerWheels', streamerWheelService.getStreamerWheels);

  return (
    <PageLayout className={css.streamerWheelPage} overflow="hidden">
      <PageTitle>Streamer Wheel Settings</PageTitle>

      <div className={css.streamerWheelPageContent}>
        <AddStreamerWheelForm onSuccess={mutate} />

        <Card className={css.streamerWheelListCard}>
          <CardHeader title="All Streamer Wheels" icon={LoaderPinwheel} />

          {isLoading ? (
            <Loader />
          ) : (
            isNonNullish(data) && (
              <Fragment>
                {isEmpty(data) ? (
                  <EmptyPlaceholder />
                ) : (
                  <div className={css.streamerWheelList}>
                    {data.map((wheel, i) => (
                      <StreamerWheelCard key={wheel.id} wheel={wheel} number={i + 1} onRevalidate={mutate} />
                    ))}
                  </div>
                )}
              </Fragment>
            )
          )}
        </Card>
      </div>
    </PageLayout>
  );
};
